export const objectToQueryString = (obj) => {
  const queryString = Object.entries(obj)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = Array.isArray(value)
        ? encodeURIComponent(value.join(','))
        : encodeURIComponent(value);
      return `${encodedKey}=${encodedValue}`;
    })
    .join('&');

  return queryString;
};

export const queryParamsToObject = (queryString = '') => {
  const query = queryString.startsWith('?') ? queryString.slice(1) : queryString;

  return query.split('&').reduce((acc, pair) => {
    if (!pair) return acc;

    const [rawKey, rawValue = ''] = pair.split('=');
    const key = decodeURIComponent(rawKey);
    const decodedValue = decodeURIComponent(rawValue);

    // Якщо значення містить кому і не порожнє — розділити на масив
    const value =
      decodedValue.includes(',') && decodedValue !== '' ? decodedValue.split(',') : decodedValue;

    acc[key] = value;
    return acc;
  }, {});
};
